import { z } from 'zod';

export const CtaLinkSchema = z.object({
	label: z.string().optional(),
	href: z.string(),
	target: z.enum(['_blank', '_self']).nullable(),
	rel: z.string().nullable(),
	isExternalLink: z.boolean(),
});
